var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('loading',{attrs:{"message":"Loading..."}})],1):(!_vm.loading && _vm.profile === null)?_c('div',[_vm._v(" No profile found. ")]):(!_vm.loading && _vm.profile !== null)?_c('div',[_c('router-view',{attrs:{"profile":_vm.profile},on:{"update:profile":_vm.load}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }